import { Turn } from './components/templates/turn'
import { Wrapper } from './components/templates/wrapper'
import 'rsuite/dist/styles/rsuite-default.css'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import './styles/app.scss'

export default function App() {
  return (
    <Wrapper>
      <Turn />
    </Wrapper>
  )
}
